var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        title: "日志详细内容",
        width: "850",
        "footer-hide": "",
        styles: { top: "50px" },
        "class-name": "ys-log-detail-modal",
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _vm.currentLog
        ? _c("div", { staticClass: "log-detail-content" }, [
            _c("div", { staticClass: "detail-header" }, [
              _c(
                "div",
                { staticClass: "header-main" },
                [
                  _c(
                    "Tag",
                    {
                      attrs: {
                        color: _vm.getBusinessTypeColor(
                          _vm.currentLog.businessType
                        ),
                        size: "large",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getBusinessTypeText(_vm.currentLog.businessType)
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _c("span", { staticClass: "business-code" }, [
                    _vm._v(_vm._s(_vm.currentLog.businessCode || "无业务编号")),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "header-sub" },
                [
                  _c("Icon", { attrs: { type: "md-clock" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatTimestamp(_vm.currentLog.timestamp)) +
                      "\n            "
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "info-grid" }, [
              _c("section", { staticClass: "info-section" }, [
                _c(
                  "div",
                  { staticClass: "section-title" },
                  [
                    _c("Icon", { attrs: { type: "md-contact" } }),
                    _vm._v(" 用户与客户"),
                  ],
                  1
                ),
                _c("div", { staticClass: "info-item-list" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("操作用户")]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.currentLog.userName || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("客户姓名")]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.currentLog.customerName || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("联系电话")]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.currentLog.customerPhone || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("成交金额")]),
                    _c("span", { staticClass: "value amount" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.currentLog.totalMoneyActual
                              ? "¥ " +
                                  _vm.currentLog.totalMoneyActual.toLocaleString(
                                    "zh-CN",
                                    { minimumFractionDigits: 2 }
                                  )
                              : "-"
                          ) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("section", { staticClass: "info-section" }, [
                _c(
                  "div",
                  { staticClass: "section-title" },
                  [
                    _c("Icon", { attrs: { type: "md-link" } }),
                    _vm._v(" 系统关联"),
                  ],
                  1
                ),
                _c("div", { staticClass: "info-item-list" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("用友订单号"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value copyable",
                        on: {
                          click: function ($event) {
                            return _vm.copyText(_vm.currentLog.ysOrderCode)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.currentLog.ysOrderCode || "未同步") +
                            " "
                        ),
                        _vm.currentLog.ysOrderCode
                          ? _c("Icon", { attrs: { type: "md-copy" } })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("用友订单ID"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value copyable",
                        on: {
                          click: function ($event) {
                            return _vm.copyText(_vm.currentLog.ysOrderId)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.currentLog.ysOrderId || "-") +
                            " "
                        ),
                        _vm.currentLog.ysOrderId
                          ? _c("Icon", { attrs: { type: "md-copy" } })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("业务UUID")]),
                    _c(
                      "span",
                      {
                        staticClass: "value uuid",
                        attrs: { title: _vm.currentLog.businessUuid },
                      },
                      [_vm._v(_vm._s(_vm.currentLog.businessUuid || "-"))]
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("苗场UUID")]),
                    _c(
                      "span",
                      {
                        staticClass: "value uuid",
                        attrs: { title: _vm.currentLog.seedFarmUuid },
                      },
                      [_vm._v(_vm._s(_vm.currentLog.seedFarmUuid || "-"))]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm.currentLog.errorMessage || _vm.currentLog.errorType
              ? _c("div", { staticClass: "error-panel" }, [
                  _c(
                    "div",
                    { staticClass: "error-header" },
                    [
                      _c("Icon", { attrs: { type: "md-alert" } }),
                      _c("span", { staticClass: "error-title" }, [
                        _vm._v(
                          "异常详情 - " +
                            _vm._s(_vm.currentLog.errorType || "Unknown Error")
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "error-body" }, [
                    _c("div", { staticClass: "error-msg" }, [
                      _vm._v(_vm._s(_vm.currentLog.errorMessage)),
                    ]),
                    _vm.currentLog.errorStackTrace
                      ? _c("div", { staticClass: "stack-trace-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "stack-header" },
                            [
                              _c("span", [_vm._v("Stack Trace")]),
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "text",
                                    ghost: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyText(
                                        _vm.currentLog.errorStackTrace
                                      )
                                    },
                                  },
                                },
                                [_vm._v("复制堆栈")]
                              ),
                            ],
                            1
                          ),
                          _c("pre", { staticClass: "stack-content" }, [
                            _vm._v(_vm._s(_vm.currentLog.errorStackTrace)),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm.currentLog.remarks
              ? _c("div", { staticClass: "remarks-panel" }, [
                  _c("div", { staticClass: "panel-title" }, [
                    _vm._v("备注信息"),
                  ]),
                  _c("div", { staticClass: "remarks-content" }, [
                    _vm._v(_vm._s(_vm.currentLog.remarks)),
                  ]),
                ])
              : _vm._e(),
          ])
        : _c(
            "div",
            { staticClass: "empty-state" },
            [
              _c("Spin", { attrs: { size: "large" } }),
              _c("p", [_vm._v("正在加载详情...")]),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }